import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminCrudListPage from '../../../components/admin/AdminCrudListPage';
import { AppButton, AppStatusBadge } from '../../../components/ui';
import secteursAdminService from '../../../services/secteursAdminService';
import { ROUTES } from '../../../config/routes';

const COLUMNS = [
  {
    key: 'nom',
    label: 'Nom',
    getValue: (row) => row.nomZone,
    render: (row) => <strong>{row.nomZone}</strong>,
  },
  {
    key: 'codeCommune',
    label: 'Code commune',
  },
  {
    key: 'codePostal',
    label: 'Code postal',
  },
  {
    key: 'secteur',
    label: 'Secteur',
    getValue: (row) => row.nomCommercial,
    render: (row) => row.nomCommercial || <span className="text-muted">—</span>,
  },
  {
    key: 'statut',
    label: 'Statut',
    getValue: (row) => (row.active ? 'active' : 'inactive'),
    render: (row) => (
      <AppStatusBadge
        status={row.active ? 'active' : 'inactive'}
        label={row.active ? 'Active' : 'Inactive'}
      />
    ),
  },
];

const SecteursAdminZonesPage = () => {
  const navigate = useNavigate();

  const load = useCallback(async (page, q, { limit } = {}) => {
    const result = await secteursAdminService.listZones({ search: q, page, limit: limit ?? 20 });
    return { rows: result.zones, pagination: result.pagination };
  }, []);

  return (
    <AdminCrudListPage
      title="Gestion des zones"
      subtitle="Délimitations des communes"
      backTo={ROUTES.secteurs.admin}
      headerExtra={(
        <AppButton as={Link} to={ROUTES.secteurs.carte} size="sm" variant="info" icon="mdi:map">
          Voir la carte
        </AppButton>
      )}
      search={{
        id: 'admin-zones-search',
        placeholder: 'Nom, code commune ou code postal…',
      }}
      columns={COLUMNS}
      load={load}
      emptyMessage="Aucune zone trouvée"
      extraActions={(z) => (
        <>
          <AppButton
            size="sm"
            variant="outline-primary"
            icon="mdi:pencil"
            title="Propriétés"
            onClick={() => navigate(ROUTES.secteurs.adminZoneEdit(z.id))}
          />
          <AppButton
            size="sm"
            variant="outline-success"
            icon="mdi:vector-polygon"
            title="Éditer le polygone"
            onClick={() => navigate(ROUTES.secteurs.adminZonePolygon(z.id))}
          />
        </>
      )}
    />
  );
};

export default SecteursAdminZonesPage;
